import React from 'react';
import ReactDOM from 'react-dom';

//@components
const App = require('router/app');

//@store
const { store } = require('store/configureStore');

// @core
const { initStoreHelper } = require('core/storeHelper');

initStoreHelper(store);

export default class OkFundsCard {
    constructor(isinCode) {
        this.isinCode = isinCode;
    }
    render(container_id) {
        ReactDOM.render(
            <App store={store} isinCode={this.isinCode} />,
            document.getElementById(container_id),
        );
    }
}
